import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal }                               from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                                       from '@angular/forms';
import { TranslateService }                             from '@ngx-translate/core';
import { UIRouter }                                     from '@uirouter/core';

import { LoanCarService }      from './loan-car.service';
import { LoanCarVehicleModel } from './typings/loan-car.vehicle';
import { MessagesService }     from '../messages/messages.service';
import { SessionService }      from '../sessions/session.service';

@Component({
  selector   : 'loan-car-vehicle',
  template: require('./loan-car.vehicle.component.html')
})
export class LoanCarVehicleComponent implements OnInit {
  private _loanVehicle : LoanCarVehicleModel;
  @Input() set loanVehicle ( _loanVehicle : LoanCarVehicleModel ) {
    const loanVehicle = _loanVehicle || ( {} as LoanCarVehicleModel );

    if ( !loanVehicle.loan_vehicle_status ) {


      loanVehicle.loan_vehicle_status = 'I';


    }

    this._loanVehicle = loanVehicle;
  }
  get loanVehicle () : LoanCarVehicleModel {
    return this._loanVehicle || ( {} as LoanCarVehicleModel );
  }

  regoLabel : string = this.sessionService.countrySettings().rego_label;;

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => LoanCarService)) private loanCarService  : LoanCarService,
    private messagesService : MessagesService,
    private sessionService  : SessionService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  delete () : void {
    this.loanCarService.deleteLoanVehicle(this.loanVehicle)
    .then(() => {
      this.activeModal.close();

      this.router.stateService.reload();

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.LOAN_VEHICLE'), 'success');
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  ngOnInit () : void {
    const company = this.sessionService.company();

    if ( company.company_variable_fields.plate_number_name ) {


      this.regoLabel = company.company_variable_fields.plate_number_name;


      };


    }

  save ( form : NgForm ) : void {
    Promise.resolve()
    .then(() => this.loanVehicle.id
      ? this.loanCarService.updateVehicle(this.loanVehicle)
      : this.loanCarService.saveVehicle(this.loanVehicle)
    )
    .then(() => {
      this.activeModal.close();

      this.router.stateService.reload();

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.LOAN_VEHICLE'), 'success');
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }
}
